import { Routes } from '@angular/router';
import { AccountComponent } from './account.component';
import { AdminLoginComponent } from './admin-login/admin-login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { AdminChangePasswordComponent } from './admin-change-password/admin-change-password.component';
import { AdminResetPasswordComponent } from './admin-reset-password/admin-reset-password.component';
import { redirectTo } from '../shared/privilege-guard';

export const AccountRoutes: Routes = [
  {
    path: '',
    component: AccountComponent,
    children: [
      {
        path: '',
        component: LoginComponent,
        canActivate: [redirectTo],
        data: {
          title: 'Login - CAL Portal',
          redirectTo: 'signin',
        },
      },
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [redirectTo],
        data: {
          title: 'Login - CAL Portal',
          redirectTo: 'signin',
        },
      },
      {
        path: 'signin',
        component: LoginComponent,
      },
      {
        path: 'signup',
        component: LoginComponent,
      },
      {
        path: 'registration',
        component: LoginComponent,
      },
      {
        path: 'admin-login',
        component: AdminLoginComponent,
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'admin-change-password',
        component: AdminChangePasswordComponent,
      },
      {
        path: 'admin-reset-password',
        component: AdminResetPasswordComponent,
      },
    ],
  },
];
